<template>
    <div>
        <div class="col-md-12 px-0 py-0" :data-phone="edition">
            <v-autocomplete outlined dense label="شهر" placeholder="نام شهر مورد نظر را جستجو کنید."
                            :error-messages="errorPhone"
                            clear-icon="mdi-close-circle-outline"
                            :value="cityInfo.city"
                            :items="city" item-text="name" item-value="id"
                            :required="force"
                            :multiple="MultiNeighbor"
                            @change="checkNeighbor($event,a)" name="city" @input="getCity($event)">
                <template v-slot:prepend-inner>
                <span class="svg-icon svg-icon-primary svg-icon-2x"><svg xmlns="http://www.w3.org/2000/svg" width="24px"
                                                                         height="24px" viewBox="0 0 24 24"
                                                                         version="1.1"><g stroke="none"
                                                                                          stroke-width="1" fill="none"
                                                                                          fill-rule="evenodd"><rect
                        x="0" y="0" width="24" height="24"/><path
                        d="M9.82829464,16.6565893 C7.02541569,15.7427556 5,13.1079084 5,10 C5,6.13400675 8.13400675,3 12,3 C15.8659932,3 19,6.13400675 19,10 C19,13.1079084 16.9745843,15.7427556 14.1717054,16.6565893 L12,21 L9.82829464,16.6565893 Z M12,12 C13.1045695,12 14,11.1045695 14,10 C14,8.8954305 13.1045695,8 12,8 C10.8954305,8 10,8.8954305 10,10 C10,11.1045695 10.8954305,12 12,12 Z"
                        fill="#000000"/></g></svg></span>
                </template>
            </v-autocomplete>
            <div v-if="neighborhood.length > 0 ">
                <v-autocomplete outlined dense label="محله" :multiple="MultiCity" :value="this.editNeighbor"
                                placeholder="نام محله مورد نظر را جستجو کنید."
                                clearable
                                chips
                                :error-messages="errorNeighbor"
                                small-chips
                                deletable-chips
                                clear-icon="mdi-close-circle-outline" name="neighborhood" id="neighborhood"
                                :items="neighborhood" item-text="name"
                                item-value="id" :key="id"
                                :required="force" @input="getNeighbor($event)">
                    <template v-slot:prepend-inner>
                <span class="svg-icon svg-icon-primary svg-icon-2x"><svg xmlns="http://www.w3.org/2000/svg" width="24px"
                                                                         height="24px" viewBox="0 0 24 24"
                                                                         version="1.1"><g stroke="none"
                                                                                          stroke-width="1"
                                                                                          fill="none"
                                                                                          fill-rule="evenodd"><rect
                        x="0" y="0" width="24" height="24"/><path
                        d="M9.82829464,16.6565893 C7.02541569,15.7427556 5,13.1079084 5,10 C5,6.13400675 8.13400675,3 12,3 C15.8659932,3 19,6.13400675 19,10 C19,13.1079084 16.9745843,15.7427556 14.1717054,16.6565893 L12,21 L9.82829464,16.6565893 Z M12,12 C13.1045695,12 14,11.1045695 14,10 C14,8.8954305 13.1045695,8 12,8 C10.8954305,8 10,8.8954305 10,10 C10,11.1045695 10.8954305,12 12,12 Z"
                        fill="#000000"/></g></svg></span>
                    </template>
                </v-autocomplete>
            </div>
        </div>
    </div>
</template>

<script>
import {Bus} from "@/main";

export default {
    name: "citySelector",
    props: {
        force: {
            type: Boolean,
            default: false
        },
        defaultEdit: {
            type: Boolean,
            default: false
        },
        editCity: {
            default: '',
            require: false
        },
        editNeighbor: {
            default: '',
            require: false
        },
        MultiCity: {
            type: Boolean,
            default: false
        },
        MultiNeighbor: {
            type: Boolean,
            default: false
        },
        auto_change: {
            default: false,
            require: true
        },

    },
    data() {
        return {
            city: [],
            neighborhood: [],
            errorPhone: '',
            errorNeighbor: '',
            a: [],
            cityInfo: {
                city: 'root',
                neighborhood: ''
            }
        }
    },
    methods: {
        getCities: function () {
            const _this = this;
            $.ajax({
                url: `${url}/user/divar/cities`,
                fn: this.getCities,
                type: 'GET',
                dataType: 'json',
                headers: {
                    Authorization: Token,
                    ACCEPT: 'application/json'
                },
                success: function (data) {
                    _this.city = data.data;
                }
            });
        },
        checkNeighbor(event, a) {
            const vm = this;
            const cityId = event
            if (cityId === "" || this.cityInfo.city.length >1 || this.cityInfo.city.length === 0)
                return;
            $.ajax({
                url: `${url}/user/divar/districts/${cityId}`,
                dataType: 'json',
                fn: this.checkNeighbor,
                msg:false,
                headers: {
                    Authorization: Token,
                    ACCEPT: 'application/json'
                },
                success: function (data) {
                    vm.neighborhood = data.data;
                }
            });
        },
        getNeighbor(val) {
            this.cityInfo.neighborhood = val;
        },
        getCity(val) {
            this.cityInfo.city = val;
        },
        edition() {
            this.cityInfo.city = this.editCity;
            this.cityInfo.neighborhood = this.editNeighbor
            if (this.editNeighbor != null) {
                this.checkNeighbor(this.editCity)
            }
        },
        validate() {
            let validate = true;

            if (this.city === undefined || this.city === 'root' || this.cityInfo.city === null) {
                this.errorPhone = 'فیلد شهر را نباید خالی بگذارید!';
                validate = false;
            } else if ((this.cityInfo.neighborhood === undefined || this.cityInfo.neighborhood === null || this.cityInfo.neighborhood === '') && this.neighborhood.length > 0) {
                this.errorNeighbor = 'فیلد محله را نباید خالی بگذارید!';
                validate = false;
            }
            return validate;
        }
    },
    watch: {
        cityInfo: {
            handler: function (val) {
                if (val.city !== undefined || val.neighborhood !== undefined) {
                    Bus.$emit('cityInfo', val);
                    this.errorPhone = '';
                    this.errorNeighbor = '';
                }
            },
            deep: true
        },
        "cityInfo.city": function (value) {
            if (value === '' || value.length >1) {
                this.neighborhood = [];
            }
        },
        auto_change: function (value) {
            if (value === true && this.cityInfo.city !== '') {
                Bus.$on('getOwnAds', function (getAds) {
                    getAds();
                })
            } else
                return false;
        },
        editCity: {
            handler: function () {
                this.edition();
            },
            deep: true
        },
        neighborhood: function (val) {
            if (val.length <= 0) {
                this.cityInfo.neighborhood = ''
            }
        }
    },
    mounted() {
        this.getCities();
        this.edition()
    },
}
</script>
<style scoped>

</style>